// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1GN8N","right":"Footer_right__1z7YC","buttons":"Footer_buttons__3idD8"};